import { push } from "connected-react-router";
import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  APPLICATION_MODE_NEW,
  ROUTE_PATH,
  APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE
} from "../../../app/constants";
import { Header, Paragraph, Button, ErrorMark } from "../../../components/RegularComponents";
import CheckboxForm from "../../../components/CheckBoxForm";
import TopNavigationBar from "../../TopNavigationBar";
import { ERROR_STRING } from "../../../app/errors";
import { setCurrentAgentMortgageProperty } from "../../../redux/slice/additionalApplicationsSlice";
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice";

const MORTGAGE_APPLICATION_PROPERTY = "confirmSuretyBond";

export const ConfrimSuretyBond = (props) => {
  const { isModal = false, onEditSave = () => {} } = props;
  const dispatch = useDispatch();

  const applicationMode = APPLICATION_MODE_NEW;
  const applicationType = APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE;

  const [confirmCheck, setConfirmCheck] = useState(false);
  const [saveApplicationError, setSaveApplicationError] = useState(false);
  const [showValidationError, setShowValidationError] = useState(false);

  const handleNext = () => {
    if (!confirmCheck) {
      setShowValidationError(true);
      return;
    }

    setShowValidationError(false);

    // Set MORTGAGE PROP value
    dispatch(
      setCurrentAgentMortgageProperty({
        key: MORTGAGE_APPLICATION_PROPERTY,
        value: true,
      })
    );

    dispatch(
      saveBusinessLicenceApplicationData(applicationType, applicationMode)
    )
      .then((data) => {
        // On to the next item
        dispatch(push(`${ROUTE_PATH.MA_APP}${ROUTE_PATH.ML_CONFIRMATION}`));
      })
      .catch((err) => {
        setSaveApplicationError(true);
      });
  };

  const handleModalClose = () => {
    // Set MORTGAGE PROP value
    dispatch(
      setCurrentAgentMortgageProperty({
        key: MORTGAGE_APPLICATION_PROPERTY,
        value: confirmCheck,
      })
    );

    onEditSave();
  };

  return (
    <>
      <div className={!isModal ? "container" : ""}>
        {!isModal && (
          <>
            <TopNavigationBar {...props} applicationType={applicationType} applicationMode={applicationMode} />
            <div className="row">
              <div className="col-xs-12 col-lg-9">
                <Header
                  style={{ paddingBottom: "30px" }}
                  id="confirm-surety-bond-header"
                  header="Surety bond"
                />
              </div>
            </div>
          </>
        )}

        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <Paragraph
              id="confirm-surety-bond-text"
              text={[
                  "A surety bond is required before your application can be processed. Confirm that you will send your surety bond to one of the following addresses before you continue."
              ]}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-9" style={{paddingBottom: "30px"}}>
            <Paragraph
              style={{margin: "0 0 0 0"}}
              id="confirm-surety-bond-address"
              text={[
                  "Mail:",
                  "Service Nova Scotia, Business Licensing",
                  "7th Floor North, Maritime Centre ",
                  "1505 Barrington Street",
                  "P.O Box 1003 ",
                  "Halifax NS B3J 2X1"
              ]}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-9" style={{paddingBottom: "30px"}}>
            <Paragraph
              style={{margin: "0 0 0 0"}}
              id="confirm-surety-bond-address"
              text={[
                  "Courier:",
                  "Service Nova Scotia, Business Licensing ",
                  "7th Floor North, Maritime Centre ",
                  "1505 Barrington Street",
                  "P.O Box 1003 ",
                  "Halifax NS B3J 2X1"
              ]}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <CheckboxForm
              id="confirm-surety-bond-checkbox"
              checked={confirmCheck}
              value={confirmCheck}
              labelText={"Yes, I confirm"}
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck(val);
              }}
            />
          </div>
        </div>

        <div className="row">
          <div
            className={
              "col-lg-4" +
              (saveApplicationError || showValidationError ? " has-error" : "")
            }
          >
            <Button
              id="complete-surety-bond-continue-button"
              style={{ margin: "0 10px 10px 0" }}
              buttonType={"regular_primary"}
              text={!isModal ? "Save and next" : "Save and close"}
              onClick={!isModal ? handleNext : handleModalClose}
            />
            {(saveApplicationError || showValidationError) && ErrorMark()}
            {showValidationError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.CONFIRM_MORTGAGE_EDUCATION_REQUIREMENT}
              </div>
            )}
            {saveApplicationError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.APPLICATION_SAVE_ERROR}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
